module.exports = __webpack_public_path__ + "img/139-Gris Basalte Lisse SFTN.jpg";